import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import UserControls from 'flarum/common/utils/UserControls';
import Button from 'flarum/common/components/Button';

import EditUserApplicationsModal from '../components/EditUserApplicationsModal';

export default () => {
    add_edit_applications_for_user_controls();
}

function add_edit_applications_for_user_controls() {
    extend(UserControls, 'moderationControls', function (items, user) {
        if (user.canEditApplications()) {
            // Add edit user applications button
            items.add(
                'edit_applications',
                <Button icon="fas fa-th" onclick={() => app.modal.show(EditUserApplicationsModal, { user })}>
                    {app.translator.trans('xtreh-phoenix.forum.user_controls.edit_user_applications')}
                </Button>
            );
        }
    });
}
